import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setIsLoading(true);
        const res = await fetch(`/api/posts/${slug}`);
        if (!res.ok) {
          throw new Error(`Failed to fetch post: ${res.status}`);
        }
        const data = await res.json();
        setPost(data);
      } catch (err) {
        setError(err.message || 'Unknown error');
      } finally {
        setIsLoading(false);
      }
    };
    fetchPost();
  }, [slug]);

  if (isLoading) {
    return (
      <div className="text-white flex justify-center items-center" style={{ minHeight: '60vh' }}>
        <h2>Loading post…</h2>
      </div>
    );
  }

  if (error || !post) {
    return (
      <div className="text-white flex justify-center items-center" style={{ minHeight: '60vh' }}>
        <div className="text-center">
          <h2>Error: {error || 'Post not found'}</h2>
          <Link to="/blog">
            <button className="px-24 py-12 primary-color-dark no-border bold br-5 nav-button mt-24">
              ← Back to Blog
            </button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-color-dark text-white px-24 py-48">
      <div className="mx-auto" style={{ maxWidth: 800 }}>
        <Link to="/blog">
          <button className="px-24 py-12 primary-color-dark no-border bold br-5 nav-button mb-24">
            ← Back to Blog
          </button>
        </Link>

        <h1 className="text-48px mb-16">{post.title}</h1>
        
        {post.user && (
          <p className="text-primary-dark text-16px mb-32">
            By {post.user.firstName} {post.user.lastName} • {post.user.username}
          </p>
        )}

        <div className="text-18px leading-relaxed whitespace-pre-wrap">
          {post.body}
        </div>
      </div>
    </div>
  );
};

export default BlogPost;

